var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 159,
    viewBox: "0 0 311 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3946_15304)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3946_15304)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0371094,
    y: 0.820312,
    width: 310,
    height: 158,
    rx: 10,
    fill: "url(#paint0_linear_3946_15304)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3946_15304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.515 18.441L281.695 4.27921C284.869 1.50077 288.945 -0.0307512 293.163 -0.0307512C296.104 -0.0307512 298.997 -0.775479 301.572 -2.19548L305.576 -4.40358C313.465 -8.75427 322.724 -9.91161 331.442 -7.63695L341.673 -4.96729C353.984 -1.75504 365.027 5.16004 373.098 14.9961C386.391 31.1972 401.585 50.461 402.403 54.3203C403.781 60.8239 407.457 84.5154 406.998 92.4125C406.724 97.1122 389.654 103.646 374.623 108.341C365.443 111.209 355.689 111.481 346.231 109.733L330.602 106.845C322.488 105.345 314.117 107.332 307.542 112.317C301.216 117.113 293.216 119.155 285.427 117.623C278.933 116.345 270.703 114.586 261.809 112.388C246.737 108.663 260.023 90.7682 270.728 80.0052C272.662 78.0609 275.208 76.8728 277.922 76.4808C283.211 75.7168 287.556 71.9111 289.009 66.7681L291.754 57.0523C294.14 48.6105 285.735 41.1389 277.631 44.497C272.98 46.4241 267.617 44.7795 264.846 40.5769L262.916 37.6509C258.86 31.4982 259.969 23.2949 265.515 18.441Z",
    fill: "#6AF0E6",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3946_15304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0796 63.8617L105.191 58.6181C106.415 57.5679 107.975 56.9905 109.588 56.9905C110.709 56.9905 111.812 56.7114 112.798 56.1783L114.325 55.3531C117.337 53.7247 120.853 53.2916 124.17 54.1401L128.053 55.1331C132.78 56.3422 137.033 58.9617 140.164 62.7042C145.218 68.7446 150.958 75.8841 151.269 77.3203C151.795 79.7529 153.197 88.6146 153.022 91.5685C152.918 93.3267 146.402 95.771 140.666 97.5274C137.162 98.6003 133.448 98.7019 129.842 98.0487L123.839 96.961C120.758 96.403 117.585 97.146 115.072 99.0134C112.655 100.81 109.621 101.574 106.663 101.004C104.181 100.526 101.029 99.8657 97.621 99.0402C91.8711 97.6471 96.9375 90.9565 101.022 86.9303C101.762 86.2006 102.73 85.7566 103.759 85.6109C105.784 85.324 107.453 83.8743 108.02 81.9084L109.003 78.4968C109.933 75.2726 106.736 72.3958 103.627 73.6586C101.864 74.3747 99.8407 73.7567 98.7786 72.1778L98.0906 71.155C96.5232 68.8248 96.9483 65.6903 99.0796 63.8617Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3946_15304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6958 -3.50522C36.4036 -9.94136 44.7545 -16.8326 50.8382 -21.6625C55.9296 -25.7047 62.5835 -26.1583 68.5449 -23.5653C76.5666 -20.0761 85.0925 -16.7644 85.4834 -18.0634C85.8893 -19.4126 93.1077 -24.5123 99.5946 -28.8393C103.779 -31.6305 109.015 -32.2858 113.802 -30.7418C122.74 -27.8588 127.606 -18.2341 124.628 -9.32716L123.972 -7.36573L114.009 16.1286C112.579 19.501 111.842 23.1266 111.842 26.7897C111.842 41.0969 100.8 52.9786 86.5308 54.0247L72.1508 55.0788C59.3211 56.0193 48.3941 45.864 48.3941 32.9999C48.3941 27.3855 46.2609 21.9808 42.4264 17.8799L37.5023 12.6137C36.2502 11.2746 34.5682 10.4171 32.749 10.1904C25.9789 9.34668 23.459 0.867596 28.6958 -3.50522Z",
    fill: "#4D8899"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3946_15304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.163 143.502C430.617 138.637 461.783 144.707 479.985 149.086C482.562 149.706 485.194 150.039 487.845 150.039H489.201C493.898 150.039 498.514 151.266 502.591 153.598C514.302 160.298 519.607 174.79 513.69 186.915C513.078 188.168 512.551 189.171 512.152 189.81C511.601 190.692 510.946 193.011 510.248 196.187C505.527 217.657 491.141 236.009 470.188 242.659C463.393 244.816 456.257 245.726 449.2 244.72C431.703 242.226 401.413 235.903 367.384 223.042C348.347 214.92 337.197 246.861 317.816 254.125C315.671 254.928 313.822 255.495 312.414 255.729C306.53 256.711 294.35 249.567 285.035 243.102C280.115 239.687 278.197 233.433 279.957 227.708C280.887 224.681 282.793 222.058 285.3 220.124C292.754 214.371 302.975 205.457 303.705 200.706C304.794 193.624 293.91 158.757 292.821 150.039C291.733 141.321 308.06 134.787 312.414 132.063C314.632 130.675 321.088 135.367 324.873 142.969C333.307 159.908 328.15 179.371 346.974 181.306C355.863 182.22 364.427 181.825 367.384 180.004C369.65 178.608 371.992 177.049 374.137 175.565C379.139 172.104 384.25 168.8 389.604 165.915C403.362 158.5 422.232 147.795 426.163 143.502Z",
    fill: "#00AAAD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3946_15304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-81.2577 25.7582C-72.4005 18.3844 -62.8073 10.4918 -55.8281 4.96828C-50.0077 0.361939 -42.4099 -0.155037 -35.6007 2.79944C-26.3771 6.80145 -16.5524 10.6097 -16.1029 9.12005C-15.6365 7.57467 -7.33714 1.72961 0.113747 -3.22521C4.9062 -6.41218 10.8961 -7.16043 16.3752 -5.39839C26.6442 -2.09588 32.2341 8.96203 28.8045 19.1894L28.0756 21.3629L16.6441 48.2416C15.0001 52.107 14.1527 56.2644 14.1527 60.465C14.1527 76.8305 1.51961 90.4207 -14.8024 91.6137L-31.5035 92.8344C-46.1783 93.9069 -58.6749 82.2904 -58.6749 67.5765C-58.6749 61.141 -61.1249 54.9468 -65.5272 50.2525L-71.1815 44.2233C-72.6157 42.6939 -74.5403 41.7149 -76.621 41.4564C-84.3848 40.4917 -87.2703 30.7639 -81.2577 25.7582Z",
    fill: "#00FFE0"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.537109,
    y: 1.32031,
    width: 309,
    height: 157,
    rx: 9.5,
    stroke: "url(#paint1_linear_3946_15304)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3946_15304",
    x: 0.0371094,
    y: 0.820312,
    width: 310,
    height: 158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3946_15304"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3946_15304",
    x: 177.337,
    y: -86.4734,
    width: 307.4,
    height: 282.298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.85,
    result: "effect1_foregroundBlur_3946_15304"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3946_15304",
    x: 17.3371,
    y: -23.9812,
    width: 213.4,
    height: 202.869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.85,
    result: "effect1_foregroundBlur_3946_15304"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3946_15304",
    x: -51.8089,
    y: -109.255,
    width: 255.013,
    height: 242.095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.85,
    result: "effect1_foregroundBlur_3946_15304"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3946_15304",
    x: 201.616,
    y: 54.1203,
    width: 392.211,
    height: 279.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.85,
    result: "effect1_foregroundBlur_3946_15304"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3946_15304",
    x: -162.181,
    y: -84.0281,
    width: 269.695,
    height: 254.634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.85,
    result: "effect1_foregroundBlur_3946_15304"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3946_15304",
    x1: 155.037,
    y1: 0.820312,
    x2: 155.037,
    y2: 158.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13293D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365385,
    stopColor: "#257BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3946_15304",
    x1: 33.0371,
    y1: 0.820313,
    x2: 289.537,
    y2: 158.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3797C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#39EFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23C7C2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3946_15304"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0371094,
    y: 0.820312,
    width: 310,
    height: 158,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient01);
export default __webpack_public_path__ + "static/media/Gradient_01.9389425127766f1469e0c3a48c1c5ca8.svg";
export { ForwardRef as ReactComponent };